export const SWIM_SET_LIBRARY = [
    {
        id: "swim_warmup_200",
        name: "Aquecimento 200m livre",
        category: "Aquecimento",
        set: {
            reps: 1,
            distance: 200,
            setType: "Aquecimento",
            style: "Livre",
            intensity: "A1",
            interval: "Direto",
            equipment: "",
            technicalFocus: "Soltar e preparar respiração",
            description: "Nado contínuo leve",
        },
    },
    {
        id: "swim_drill_4x50",
        name: "4x50 educativo crawl",
        category: "Técnica",
        set: {
            reps: 4,
            distance: 50,
            setType: "Educativo",
            style: "Crawl",
            intensity: "Leve",
            interval: "20s",
            equipment: "Prancha",
            technicalFocus: "Cotovelada alta e alinhamento",
            description: "Alternar 25m educativo + 25m nado completo",
        },
    },
    {
        id: "swim_main_8x100_a2",
        name: "8x100 ritmo A2",
        category: "Principal",
        set: {
            reps: 8,
            distance: 100,
            setType: "Principal",
            style: "Crawl",
            intensity: "A2",
            interval: "1:45",
            equipment: "",
            technicalFocus: "Ritmo constante",
            description: "Manter tempo estável do primeiro ao último 100",
        },
    },
    {
        id: "swim_speed_12x25",
        name: "12x25 velocidade",
        category: "Velocidade",
        set: {
            reps: 12,
            distance: 25,
            setType: "Velocidade",
            style: "Livre",
            intensity: "Máximo",
            interval: "45s",
            equipment: "",
            technicalFocus: "Saída forte e finalização",
            description: "Alta qualidade, descanso completo",
        },
    },
    {
        id: "swim_cooldown_100",
        name: "Soltura 100m",
        category: "Soltura",
        set: {
            reps: 1,
            distance: 100,
            setType: "Soltura",
            style: "Costas",
            intensity: "Leve",
            interval: "Direto",
            equipment: "",
            technicalFocus: "Relaxar ombros",
            description: "Solto e confortável",
        },
    },
];
